var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CollapsibleGroup from "./CollapsibleGroup";
import PhraseRow from "./PhraseRow";
/** Gerencia uma lista de frases (chamadas, informações adicionais...) com criar/excluir. */
function PhraseManager(_a) {
    var title = _a.title, addLabel = _a.addLabel, items = _a.items, onCreate = _a.onCreate, onDelete = _a.onDelete, defaultOpen = _a.defaultOpen;
    var _b = useState(false), adding = _b[0], setAdding = _b[1];
    var _c = useState(""), text = _c[0], setText = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    function handleCreate() {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = text.trim();
                        if (!value || saving)
                            return [2 /*return*/];
                        setSaving(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, onCreate(value)];
                    case 2:
                        _a.sent();
                        setText("");
                        setAdding(false);
                        return [3 /*break*/, 4];
                    case 3:
                        setSaving(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsx(CollapsibleGroup, __assign({ title: title, count: items.length, defaultOpen: defaultOpen }, { children: _jsxs("div", __assign({ className: "phrase-list" }, { children: [items.map(function (item) { return (_jsx(PhraseRow, { value: item.label, onDelete: function () { return onDelete(item.id); } }, item.id)); }), adding ? (_jsxs("div", __assign({ className: "phrase-row phrase-row-editing" }, { children: [_jsx("input", { className: "input-art-generator-default phrase-input", autoFocus: true, value: text, onChange: function (e) { return setText(e.target.value); }, onKeyDown: function (e) {
                                if (e.key === "Enter")
                                    handleCreate();
                                if (e.key === "Escape") {
                                    setAdding(false);
                                    setText("");
                                }
                            }, placeholder: addLabel }), _jsx("button", __assign({ type: "button", className: "continue-button blue-button phrase-save", onClick: handleCreate, disabled: saving || !text.trim() }, { children: "Salvar" })), _jsx("button", __assign({ type: "button", className: "settings-add-button", onClick: function () {
                                setAdding(false);
                                setText("");
                            } }, { children: "Cancelar" }))] }))) : (_jsxs("button", __assign({ type: "button", className: "settings-add-button", onClick: function () { return setAdding(true); } }, { children: [_jsx(AddIcon, { fontSize: "small" }), " ", addLabel] })))] })) })));
}
export default PhraseManager;
